import logo from 'assets/logos/oof_final-02.png';
import { Button, Container } from 'components/common';
import { Header } from 'components/theme';
import React, { useState } from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { Parallax } from 'react-scroll-parallax';
import { Center, IntroWrapper, Thumbnail, Wrapper } from './styles';

export const Intro = () => {
  const [sidebar, toggle] = useState(false);

  return (
    <Wrapper sidebar={sidebar}>
      <Header sidebar={sidebar} toggle={toggle} />
      <IntroWrapper as={Container}>
        <Center>
          <Parallax y={[-20, 20]} tagOuter="figure">
            <Thumbnail>
              <img src={logo} alt="MAXREC Maksymilian Grela" />
            </Thumbnail>

            <Button transparent as={AnchorLink} href="#about-us">
              Rozpocznij
            </Button>
          </Parallax>
        </Center>

        {/* <Bottom>
          <Links>
            {social.map(({ id, name, link, icon }) => (
              <a key={id} href={link} target="_blank" rel="noopener noreferrer">
                <img width="35" src={icon} alt={name} />
              </a>
            ))}
          </Links>
        </Bottom> */}
      </IntroWrapper>
    </Wrapper>
  );
};
